import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {FormControl} from '@angular/forms';

import {RequestParameters} from '../../models/request-parameters/parameter.model';
import { UsersCollectorService } from '../../../users/users-collector/users-collector.service';

@Component({
  selector: 'app-collect-sub-user-permissions-autocomplete',
  templateUrl: './collect-sub-user-permissions-autocomplete.component.html',
  styleUrls: ['./collect-sub-user-permissions-autocomplete.component.scss']
})
export class CollectSubUserPermissionsAutocompleteComponent implements OnInit {

  @Input('permissionFormControl') permissionFormControl: FormControl;
  @Input('placeholder') placeholder: string;
  @Output() onPermissionSelected: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('autoParent') autoParent: ElementRef;

  permissions: any  = [];
  permissionLoading: boolean = true;
  permissionParameters: RequestParameters = new RequestParameters();
  organizationValue: any;

  constructor(private userCollectService: UsersCollectorService  ) { }

  ngOnInit() {
      this.updatePermission();
  }

  onSelectPermission() {
    this.onPermissionSelected.emit(this.permissionFormControl.value);
  }


  displayPermission (permission: any) {
    if (permission !== null) {
      return permission.name;
    }
  }

  filterAgencies (filterInput: string = '') {
    if (this.permissionParameters.searchString !== filterInput) {
      this.permissionParameters.searchString = filterInput;
      this.updatePermission();
    }
  }

  updatePermission () {
    this.permissionLoading = true;
    this.userCollectService.getCollectSubUserPermissions(this.permissionParameters)
      .subscribe(
        (response) => {
          this.permissions = response.result;
          this.permissionLoading = false;
        }
      );
  }

  onPermissionsChange(e) {
    this.onPermissionSelected.emit(e) ;
  }

  compareWithFn(item1, item2) {
    return item1 && item2 ? item1.reference === item2.reference : item1 === item2;
  }
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/collect-sub-user-permissions-autocomplete/collect-sub-user-permissions-autocomplete.component.ts